// extracted by mini-css-extract-plugin
export default {"editButton":"onetimeAllowance_editButton__eulkS","TableBody":"onetimeAllowance_TableBody__tj3lz","deleteButton":"onetimeAllowance_deleteButton__tmHf0"};